'use client';

import { Button } from '@/components/ui';
import { IconEdit } from '@repo/svgs';
import React from 'react';
import { useBuilding } from '../context/BuildingProvider';
import { cn } from '@/lib/cn';
import { useRouter } from 'next/navigation';
import { useAnalytics } from '@/hooks/useAnalytics';
import { useStore } from '@/providers/StoreProvider';
import { clearSubmittedReviewRedirect } from '@/app/review/submittedReviewRedirect';

function ReviewYourBuilding() {
  const { building, isMasked } = useBuilding();

  const analytics = useAnalytics();

  const isLoggedIn = useStore(state => state.webAuth.isLoggedIn);

  const router = useRouter();

  const handleReview = () => {
    analytics.track('building_review_prompt', {
      type: 'edit review',
      buildingId: building?.slug,
      addressSlug: building?.primaryAddress?.slug,
    });
    if (building?.slug) {
      clearSubmittedReviewRedirect(building.slug);
    }
    router.push(`/review/${building?.slug}`);
  };

  if (isMasked || !isLoggedIn) {
    return null;
  }

  return (
    <div className="md:hidden py-4">
      <div className={cn('flex gap-1 items-center px-2 py-1')}>
        <h3 className="text-heading-6 text-primary">
          Review {building?.primaryAddress?.streetAddress || 'this building'}
        </h3>
      </div>
      <div className={cn('flex flex-col gap-4 items-start px-2 py-0 w-full')}>
        <p className="text-body-2 text-primary w-full">
          Reviews are anonymous and could truly help the next renter that considers this building.
        </p>
        <div className="flex flex-col gap-2 items-start w-full">
          <div className="flex flex-col gap-4 items-start justify-center w-full">
            <Button
              variant="primary"
              size="md"
              fullWidth
              onClick={() => handleReview()}
              iconLeft={<IconEdit className="h-4 w-4 icon-inverted" />}
            >
              Review this building
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReviewYourBuilding;
